import type { FaireProductEntity } from "../../entity_types/product";

export const p_mkcrfemyyn: FaireProductEntity = {
  token: "p_mkcrfemyyn",
  type: "product",
  name: "Pure Liquid Shilajit Resin | Natural Energy & Fulvic Acid",
  brandToken: "b_etjm2nc4kj",
  brandName: "aquaViv",
  imageUrl:
    "https://cdn.faire.com/fastly/86ab87ee4736104b272676141c085c596496ce61ac274d52909759deb2b168b1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59ee17d3f3e4fd9b3c756210527947984a90380fce42dba8f5085f2aacce7028.png",
  ],
  priceDollars: 26.33,
  description:
    "Liquid Shilajit Drops - Himalayan Vitality, Refined\n\nDrawn from the heart of the Himalayas and liquefied through precision alchemy, aquaViv Liquid Shilajit Drops deliver the living intelligence of nature’s most potent mineral resin.\n\nHarvested by authentic Nepalese Sherpas from high-altitude rock strata, our raw shilajit is purified and infused into structured, infoceutically tuned water—enhancing cellular uptake and energetic coherence. Each milliliter provides 500 mg of active shilajit containing fulvic acids, trace minerals, and naturally occurring adaptogenic compounds that help the body adapt, energize, and renew.\n\nSupports:\n• Mental clarity and sustained focus\n• Energy, endurance, and recovery\n• Healthy aging and cellular repair\n• Digestive balance and nutrient absorption\n• Radiant skin, hair, and vitality\n\nPackaged in biophotonic glass to shield from light and microplastic transfer, each drop preserves the living essence of the mountain itself—an ancient source of elemental strength and modern bioenergetic balance.\n\nStructured. Intelligent. Alive.\n",
  tags: [],
  msrpDollars: 52.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:57.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
